const AUTH_CODE_EXCHANGE_KEY = '__jupiterAuthCodeExchange__';

/**
 * Single-flight guard for the Auth0 authorization-code exchange.
 *
 * Introduced when the legacy (`@peloton/auth`) and new (`@auth/oauth`)
 * providers were dual-mounted during the auth migration: both observed the
 * `?code=&state=` callback params and would each call
 * `handleRedirectCallback()`. The code is single-use, so the second exchange
 * fails with `invalid_grant`. Memoizing the in-flight promise on `window`
 * ensures only ONE client consumes the code; any other provider awaits the
 * same result.
 *
 * The legacy provider is gone (DISCO-517). Moved here from `@peloton/auth`
 * unchanged; remove once it is confirmed no route mounts two `AuthProvider`s
 * for the same Auth0 application.
 */
export const exchangeAuthorizationCodeOnce = <T>(
  exchange: () => Promise<T>,
): Promise<T> => {
  const w = window as unknown as {
    __jupiterAuthCodeExchange__?: Promise<unknown>;
  };
  if (!w[AUTH_CODE_EXCHANGE_KEY]) {
    w[AUTH_CODE_EXCHANGE_KEY] = exchange();
  }
  return w[AUTH_CODE_EXCHANGE_KEY] as Promise<T>;
};
